export default __webpack_public_path__ + "static/media/right-arrow (1) 1.9e76cc96.svg";